/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import {ACCESS_TOKEN_KEY} from "../../utilities/Constants";

export async function getAll(tableName) {

    try {
        const url = process.env.REACT_APP_API_URL + "getall/"
        const request = {
            method: "POST",
            body: JSON.stringify({
                "ACCESS_TOKEN": {
                    "S": JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY)).accessToken
                }
            })
        }
        let path;
        switch (tableName) {
            case "EFFECTIVITY":
                path = "effectivities"
                break
            case "PARTS":
                path = "parts"
                break
            case "PRINTERS":
                path = "printers"
                break
            case "TAGS":
                path = "tags"
                break
            default:
                throw new Error("BAD ENDPOINT");
        }
        const response = await fetch(url + path, request);
        const json = await response.json();
        if (json.statusCode !== 200) {
            throw new Error("STATUS: " + json.statusCode);
        }
        return json;
    } catch (error) {
        return {
            statusCode: 500,
            body: {
                message: error.message
            }
        }
    }
}
